import { createSlice } from "@reduxjs/toolkit";
import VerikontrolDTO from "src/models/Genel/VerikontrolDTO";
import MapReducerPayloads from "src/models/store/MapReducerPayloads";
import { veriKontrolApi } from "src/services/Base/VeriKontrolApi";

interface IVerikontrolState {
  data: Array<VerikontrolDTO>
}
const VerikontrolSlice = createSlice<IVerikontrolState, MapReducerPayloads<IVerikontrolState, {
}>>({
  name: 'user',
  initialState: {
    data: []
  },
  reducers: {
  },
  extraReducers: (builder) => {
    builder.addMatcher(veriKontrolApi.endpoints.getByOrganizasyonId.matchFulfilled, (state, action) => {
      return {
        ...state,
        data: action.payload
      };
    })
  }
})
export default VerikontrolSlice;